import axios, { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import { useAxios, apiEndpoints } from 'api';
import { AutoAlertStatus } from 'components';
import { QualificationsAdditionalParam } from 'api/types/Qualifications';
import {
  AuthorizationTechnicalModel,
  TechnicalDeviceModel,
  TechnicalTDTModel,
  TechnicalUDTModel,
} from 'api/types/Technical';

// START Technical UDT

const useGetTechnicalUDT = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: QualificationsAdditionalParam) => void,
  TechnicalUDTModel[] | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    TechnicalUDTModel[] | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: QualificationsAdditionalParam) => {
      ax.get<TechnicalUDTModel[]>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/qualification/technical-udt`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

// END Technical UDT

// START Technical TDT

const useGetTechnicalTDT = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: QualificationsAdditionalParam) => void,
  TechnicalTDTModel[] | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    TechnicalTDTModel[] | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: QualificationsAdditionalParam) => {
      ax.get<TechnicalTDTModel[]>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/qualification/technical-tdt`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

// END Technical TDT

// START Technical Device

const useGetTechnicalDevice = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: QualificationsAdditionalParam) => void,
  TechnicalDeviceModel[] | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    TechnicalDeviceModel[] | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: QualificationsAdditionalParam) => {
      ax.get<TechnicalDeviceModel[]>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/qualification/technical-device`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

// END Technical Device

// START Authorization Technical

const useGetAuthorizationTechnical = (
  onError?: (error: AxiosError<Error>) => void
): [
  (additionalParam: QualificationsAdditionalParam) => void,
  AuthorizationTechnicalModel[] | null | undefined
] => {
  const ax = useAxios();
  const [getedData, setGetedData] = useState<
    AuthorizationTechnicalModel[] | null | undefined
  >(undefined);

  const doGet = useCallback(
    (additionalParam: QualificationsAdditionalParam) => {
      ax.get<AuthorizationTechnicalModel[]>(
        `${apiEndpoints.employeeKiosk}/user/${additionalParam.userId}/authorization/technical`
      )
        .then(({ data }) => {
          setGetedData(data);
        })
        .catch((error) => {
          if (error.response) {
            AutoAlertStatus({
              status: error.response.status,
              customMsg: JSON.parse(error.response?.request.response).message,
            });
          }
          if (onError) onError(error);
        });
    },
    [ax, onError]
  );

  return [doGet, getedData];
};

// END Authorization Technical

export default {
  useGetTechnicalUDT,
  useGetTechnicalTDT,
  useGetTechnicalDevice,
  useGetAuthorizationTechnical,
};
